import JSZip from 'jszip';

import { Injectable } from '@angular/core';

type CsvRow = string[] | Record<string, string>;

@Injectable({
  providedIn: 'root',
})
export class CsvService {
  dataType: symbol | undefined;
  data: CsvRow[] = [];

  exportChartData(data: CsvRow[], filename: string): void {
    this.data = data;
    this.save(filename + '.csv');
  }

  async exportChartDataAsZip(
    data: { [filename: string]: CsvRow[] },
    zipFilename: string,
  ): Promise<void> {
    const zip = new JSZip();
    for (const [filename, csvData] of Object.entries(data)) {
      const csvStr = this.tableDataToCsv(csvData).join('\r\n');
      // UTF-8 BOM とデータを結合
      const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
      const csvContent = new TextEncoder().encode(csvStr);
      const csvDataWithBom = new Uint8Array(bom.length + csvContent.length);
      csvDataWithBom.set(bom, 0);
      csvDataWithBom.set(csvContent, bom.length);
      zip.file(`${filename}.csv`, csvDataWithBom, { binary: true });
    }
    const content = await zip.generateAsync({ type: 'blob' });
    this.saveZip(content, zipFilename);
  }

  private saveZip(content: Blob, filename: string): void {
    const a = document.createElement('a');
    const blobURL = URL.createObjectURL(content);

    a.style.display = 'none';
    a.download = decodeURI(filename);
    a.href = blobURL;

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    setTimeout(() => {
      URL.revokeObjectURL(blobURL);
    }, 100);
  }

  tableDataToCsv(tableData: CsvRow[]) {
    return tableData.map((row: CsvRow) => {
      const array = Array.isArray(row) ? row : Object.values(row);
      return array
        .map((value: string | number | null | undefined) => {
          // null/undefined チェック
          if (value == null) {
            return '""';
          }

          const str = String(value).trim();
          // すべての文字列を"で囲む
          return `"${str.replace(/"/g, '""')}"`;
        })
        .join(',');
    });
  }

  private save(filename = 'data.csv'): void {
    // .csv拡張子がない場合は .csv を付与
    if (!filename.match(/\.csv$/i)) {
      filename = `${filename}.csv`;
    }

    // 改行コードを \n に変更
    const csvStr = this.tableDataToCsv(this.data).join('\r\n');

    // UTF-8 BOM とデータを結合
    const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
    const csvContent = new TextEncoder().encode(csvStr);
    const csvData = new Uint8Array(bom.length + csvContent.length);
    csvData.set(bom, 0);
    csvData.set(csvContent, bom.length);

    const blob = new Blob([csvData], {
      type: 'text/csv;charset=utf-8',
    });

    const a = document.createElement('a');
    const blobURL = URL.createObjectURL(blob);

    a.style.display = 'none';
    a.download = decodeURI(filename);
    a.href = blobURL;

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    setTimeout(() => {
      URL.revokeObjectURL(blobURL);
    }, 100);
  }
}
